import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CounterBidDisclosureComponent } from '../counter-bid-disclosure/counter-bid-disclosure.component';

@Component({
  selector: 'app-user-terms',
  templateUrl: './user-terms.component.html',
  styleUrls: ['./user-terms.component.scss'],

  imports: [RouterLink, CounterBidDisclosureComponent],
})
export class UserTermsComponent {}
